// extracted by mini-css-extract-plugin
export var absolute = "Loading-module--absolute--af557";
export var core = "Loading-module--core--96438";
export var dash = "Loading-module--dash--942a5";
export var rotation = "Loading-module--rotation--055ba";
export var spinner = "Loading-module--spinner--c5426";